module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xthor3-74a6dd839c245179a717b5c463fabc40.jpg";